import { callApi } from './api';

import { ApiResult } from '@/types/api';
import { SearchChildren, ChildrenSearchParams } from '@/types/child';

export const getChildren = async (
  childrenSearchParams: ChildrenSearchParams,
  loginUserEmail?: string
): Promise<ApiResult<SearchChildren>> => {
  const {
    limit,
    offset,
    word,
    recipientCertificateEndDateFrom,
    recipientCertificateEndDateTo,
    supportEndDateFrom,
    supportEndDateTo,
    hasUpperManagement,
    schoolGrade,
    schoolName,
    city,
  } = childrenSearchParams;

  const params = new URLSearchParams({
    limit: limit,
    offset: offset,
  });
  if (word) {
    params.append('word', word);
  }
  if (recipientCertificateEndDateFrom) {
    params.append('recipientCertificateEndDateFrom', recipientCertificateEndDateFrom);
  }
  if (recipientCertificateEndDateTo) {
    params.append('recipientCertificateEndDateTo', recipientCertificateEndDateTo);
  }
  if (supportEndDateFrom) {
    params.append('supportEndDateFrom', supportEndDateFrom);
  }
  if (supportEndDateTo) {
    params.append('supportEndDateTo', supportEndDateTo);
  }
  if (hasUpperManagement) {
    params.append('hasUpperManagement', hasUpperManagement.toString());
  }
  if (schoolGrade) {
    params.append('schoolGrade', schoolGrade);
  }
  if (schoolName) {
    params.append('schoolName', schoolName);
  }
  if (city) {
    params.append('city', city);
  }
  const searchParams = new URLSearchParams(params);
  const { status, result } = await callApi<SearchChildren>(
    `children`,
    'GET',
    searchParams,
    undefined,
    loginUserEmail,
    undefined,
    true
  );
  return { status, result };
};
